import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAdminUser, ISignInData } from '../../models/auth/signIn.model';

interface IInitialState {
  isAuthenticated: boolean;
  authData?: ISignInData | null;
}
const initialState: IInitialState = {
  isAuthenticated: false,
  authData: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthentication(state, action: PayloadAction<IInitialState>) {
      state.authData = action.payload.authData;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    setTokens(state, action: PayloadAction<{ accessToken: string; refreshToken: string }>) {
      if (state.authData) {
        state.authData.accessToken = { token: action.payload.accessToken };
        state.authData.refreshToken = { token: action.payload.refreshToken };
      }
    },
    setAdminProfile(state, action: PayloadAction<IAdminUser>) {
      if (state.authData) {
        state.authData.user = action.payload;
      }
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
